// @flow

import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { Box, Button, TextField } from 'gestalt';
import { URL, getErrors } from 'app/common/lib/react/validator';

type Props = {|
  onComplete: () => void,
  onDismiss: () => void,
  onWebsiteInputChange?: (urlInput: string) => void,
  websiteUrl?: ?string,
|};

type State = {|
  websiteUrl: ?string,
  websiteUrlErrors?: Array<string>,
|};

// eslint-disable-next-line no-unused-vars
const stageTranslations = () => {
  // Staging translations: Replacing validators with the versions in app/packages/validators/validator
  // These validators must be passed error messages explicitly
  // See CUI-3594

  // URL({ message })
  i18n._('Not a valid url.', '[m10n] Validation error when a url is not a valid format');
};

export default class UserWebsiteInput extends Component<Props, State> {
  state = {
    websiteUrl: this.props.websiteUrl || '',
    websiteUrlErrors: [],
  };

  validators = {
    websiteUrl: [URL()],
  };

  handleWebsiteChange = ({ value }: { value: string }) => {
    const websiteUrlErrors = getErrors(this.validators.websiteUrl, value);

    this.setState({
      websiteUrl: value,
      websiteUrlErrors,
    });

    const { onWebsiteInputChange } = this.props;
    if (onWebsiteInputChange) {
      onWebsiteInputChange(value);
    }
  };

  render() {
    const { onDismiss, onComplete } = this.props;
    const { websiteUrlErrors } = this.state;
    return (
      <Modal
        accessibilityCloseLabel={i18n._('Close', 'Modal close label')}
        accessibilityModalLabel={i18n._(
          "What's your website",
          'Accessibility label for modal to input user website',
        )}
        heading={i18n._("What's your website", 'Header for the user website input modal.')}
        onDismiss={onDismiss}
        size="sm"
        footer={
          <Box alignItems="center" column={12} display="flex" justifyContent="end" paddingX={2}>
            <Box flex="shrink" paddingX={4} data-test-id="user-website-input-close">
              <Button
                color="gray"
                text={i18n._(
                  'Cancel',
                  'Button label for cancelling the action to set profile cover pins',
                )}
                onClick={onDismiss}
              />
            </Box>
            <Box flex="shrink" data-test-id="user-website-input-next">
              <Button
                color="red"
                text={i18n._('Next', 'Button label for opening the claim website modal')}
                onClick={(e) => {
                  onDismiss();
                  onComplete();
                }}
              />
            </Box>
          </Box>
        }
      >
        <Box height={130} padding={6}>
          <TextField
            id="userWebsite"
            name="website_url"
            errorMessage={websiteUrlErrors && websiteUrlErrors.join(', ')}
            onChange={this.handleWebsiteChange}
            placeholder={i18n._(
              'www.red-shoes-online.com',
              'Sample website prompt for claiming a website',
            )}
            value={this.state.websiteUrl || ''}
          />
        </Box>
      </Modal>
    );
  }
}
